export type PlayMode = 'computer' | 'friend'
export type PlayLevel = 'easy' | 'medium' | 'hard'
export type PlayColor = 'white' | 'random' | 'black'

export const PLAY_LEVELS: { id: PlayLevel, label: string, hint: string, engineLevel: number }[] = [
    { id: 'easy', label: 'Easy', hint: "Learning the ropes", engineLevel: 1 },
    { id: 'medium', label: 'Medium', hint: "A real fight", engineLevel: 2 },
    { id: 'hard', label: 'Hard', hint: "Bring your best", engineLevel: 3 }
]

export const PLAY_COLORS: { id: PlayColor, label: string }[] = [
    { id: 'white', label: 'White' },
    { id: 'random', label: 'Random' },
    { id: 'black', label: 'Black' }
]

export const DEFAULT_LEVEL: PlayLevel = 'medium'
export const DEFAULT_COLOR: PlayColor = 'white'

export const isPlayLevel = (value: unknown): value is PlayLevel => PLAY_LEVELS.some(level => level.id === value)
export const isPlayColor = (value: unknown): value is PlayColor => PLAY_COLORS.some(color => color.id === value)

export const playHref = (mode: PlayMode, level: PlayLevel = DEFAULT_LEVEL, color: PlayColor = DEFAULT_COLOR): string => {
    return mode === 'friend' ? '/play?mode=friend' : `/play?mode=computer&level=${level}&color=${color}`
}
